import { useFormContext } from 'react-hook-form';
import styled from 'styled-components';
import { InputWrapper } from 'components/auth_flow/SharedComponents';
import BookingCalendarWrapper, { DesktopWrapper } from 'components/calendar/BookingCalendarWrapper';
import React, { useState } from 'react';
import { StyledCalendar } from 'components/calendar/NewBookingCalendar';
import dayjs from 'dayjs';
import CalendarIcon from 'assets/scss/fortawesome/icons/svg/calendar-2.svg';
import InputTextWithMask from 'components/ui/InputTextWithMask/InputTextWithMask';
import ErrorMessage from 'components/ui/ErrorMessage/ErrorMessage';
import { useBreakpoint } from '../BreakpointProvider';

const BirthdateFields = () => {
  const { register, errors, setValue, getValues, trigger } = useFormContext();
  const breakpoints = useBreakpoint();
  const smallScreen = breakpoints.xs || breakpoints.sm;
  const [showCalendar, setShowCalendar] = useState(false);

  const minDate = dayjs().subtract(120, 'years');
  const maxDate = dayjs().subtract(18, 'years');

  const formBirthdate = dayjs(getValues('birthdate'), 'MM/DD/YYYY', true);
  const currentDate = formBirthdate.isValid() ? formBirthdate : maxDate;

  const isBirthdateEmpty = (input: string) => input === 'mm/dd/yyyy' || input === '' || input === undefined;

  return (
    <CustomInputWrapper>
      <label htmlFor={smallScreen ? 'mobileDatePicker' : undefined}>
        <InputTextWithMask
          onChange={(e) => {
            if (!isBirthdateEmpty(e.target.value)) {
              trigger('birthdate');
            }
          }}
          maskPlaceholder="mm/dd/yyyy"
          mask="99/99/9999"
          type="tel"
          bold={false}
          bottomSpacing={false}
          hasError={!!errors.birthdate}
          hasValue={!isBirthdateEmpty(getValues('birthdate'))}
          label="Birthdate"
          name="birthdate"
          inputRef={register({
            required: 'Please enter birthday',
            pattern: {
              value: /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/,
              message: 'Sorry, this date is not valid',
            },
            validate: (date) => {
              const d = dayjs(date, 'MM/DD/YYYY', true);
              if (!d.isValid() || d.isBefore(minDate)) return 'Sorry, this date is not valid';
              if (dayjs().diff(d, 'years') < 18) return 'Sorry, you must be at least 18 years old to sign up';
              return true;
            },
          })}
          dataTestId="signup-birthdate-input"
        />
        <StyledArrow
          width="15px"
          onClick={() => {
            if (!smallScreen) setShowCalendar(true);
          }}
        />
        {smallScreen && (
          <HiddenDateInput
            onChange={(e) => {
              setValue('birthdate', dayjs(e.target.value).format('MM/DD/YYYY'), {
                shouldValidate: true,
              });
            }}
            name="mobileDatePicker"
            id="mobileDatePicker"
            type="date"
            min={minDate.format('YYYY-MM-DD')}
            max={maxDate.format('YYYY-MM-DD')}
          />
        )}
      </label>
      <ErrorMessage error={errors.birthdate} />
      {showCalendar && (
        <StyledBookingCalendarWrapper
          onChange={(e) => {
            setValue('birthdate', dayjs(e).format('MM/DD/YYYY'), {
              shouldValidate: true,
            });
            setShowCalendar(false);
          }}
          hideMultiDay
          hidePrice
          autoApply
          minDate={minDate.toDate()}
          maxDate={maxDate.toDate()}
          shownDate={currentDate.toDate()}
          date={currentDate.toDate()}
          monthsToShow={1}
          showApply={false}
          showCancel={false}
          toggleCall={() => {
            setShowCalendar(false);
          }}
          isBirthDate
          mobile={false}
          dontFetch
          showMonthAndYearPickers
        />
      )}
    </CustomInputWrapper>
  );
};

const StyledArrow = styled(CalendarIcon)`
  position: absolute;
  cursor: pointer;
  padding: 10px;
  box-sizing: content-box;
  top: 25px;
  transform: translateY(-50%);
  right: 5px;

  path {
    fill: #b1b3b6;
  }
`;

const HiddenDateInput = styled.input`
  opacity: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  bottom: 0;
`;

const StyledBookingCalendarWrapper = styled(BookingCalendarWrapper)`
  ${StyledCalendar} {
    width: 100%;
  }

  &${DesktopWrapper} {
    position: absolute;
    top: 120px;
    left: 50px;
    width: 100%;

    .rdrMonth,
    .rdrCalendarWrapper {
      width: 100%;
    }
  }
`;

const CustomInputWrapper = styled(InputWrapper)`
  position: relative;
  cursor: pointer;
  #birthdate {
    border: 1px solid #8e9697;
  }

  #mobileDatePicker::-webkit-calendar-picker-indicator {
    background: transparent;
    bottom: 0;
    color: transparent;
    cursor: pointer;
    height: auto;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: auto;
  }
`;

export default BirthdateFields;
